import React from 'react';
import PropTypes from 'prop-types';
import { BASE_URL } from '../constants';
import './Nav.css';

const Nav = props => {
  const { onClick } = props;
  return (
    <nav>
      <button className='hamburguesa' type='button' onClick={onClick}>
        <img src={`${BASE_URL}/images/hamburguesa.png`} alt='Menu' />
      </button>
      <img
        src={`${BASE_URL}/images/nav-logo.png`}
        alt='Logo'
        className='nav-logo'
      />
    </nav>
  );
};
export default Nav;

Nav.defaultProps = {
  onClick: null,
};

Nav.propTypes = {
  onClick: PropTypes.func,
};
